import React from 'react';
import { Div, Typography } from '@icecreamsocial/components';

export const Footer = ({ termsURL, privacyURL }) => (
	<Div
		as="footer"
		backgroundColor="ambientLight"
		borderColor="ambient"
		borderTop="1px solid"
		padding="xlg"
		textAlign="center"
		typoSize=".8em"
	>
		<Div margin={['sm', 'md']}>
			<Typography.Span textColor="ambientDark">
				Powered by{' '}
				<Typography.A
					href="https://icecreamsocial.io"
					target="_blank"
					textColor="body"
					visitedTextColor="body"
				>
					Ice Cream Social
				</Typography.A>
			</Typography.Span>
		</Div>
		<Div display="inline-flex" margin={['sm', 'md']} style={{ gap: '12px' }}>
			<Typography.A
				href={termsURL}
				target="_blank"
				textColor="body"
				visitedTextColor="body"
			>
				Terms and Conditions
			</Typography.A>
			<Typography.Span>|</Typography.Span>
			<Typography.A
				href={privacyURL}
				target="_blank"
				textColor="body"
				visitedTextColor="body"
			>
				Privacy Policy
			</Typography.A>
		</Div>
	</Div>
);
